import { catchError, filter, map, switchMap } from 'rxjs/operators';
import { concat, EMPTY, of } from 'rxjs';
import axios from 'axios-observable';
import { PayloadEpic } from '@/store/epics/epic-types';
import { actions, asyncActions } from '@/store/slices';
import { apiEndpoints } from '@/store/constants';
import { FetchInventoryAllergensPayload } from '@/store/slices/payload-types/asset-payload-types';
import { objectToUrlSearchParams } from '@/utils/url-search-params-utils';
import { InventoryAllergenModel } from '@/models';

export const fetchAllInventoryAllergensEpic: PayloadEpic<FetchInventoryAllergensPayload, InventoryAllergenModel[]> = (action$) => {
    return action$.pipe(
        filter(asyncActions.inventoryAllergens.fetchAll.match),
        switchMap(({ payload }) => concat(
            of(actions.inventoryAllergens.setIsLoading(true)),
            fetchAllergens(payload).pipe(
                map(({ data }) => actions.inventoryAllergens.setAll(data.results)),
                catchError((error) => {
                    console.error('fetchAllInventoryAllergensEpic', error);

                    return EMPTY;
                }),
            ),
            of(actions.inventoryAllergens.setIsLoading(false)),
        )),
    );
};

const fetchAllergens = (payload: FetchInventoryAllergensPayload) => {
    const searchParams = objectToUrlSearchParams(payload);

    return axios.get<ListResponse<InventoryAllergenModel>>(`${apiEndpoints.inventoryAllergens()}?${searchParams}`);
};
